/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_Inbox_SubInputs */

const en_notify_inbox_sub = /** @type {(inputs: Notify_Inbox_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When friends send you a recipe`)
};

const de_notify_inbox_sub = /** @type {(inputs: Notify_Inbox_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Freunde euch ein Rezept senden`)
};

/**
* | output |
* | --- |
* | "When friends send you a recipe" |
*
* @param {Notify_Inbox_SubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_inbox_sub = /** @type {((inputs?: Notify_Inbox_SubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_Inbox_SubInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_inbox_sub(inputs)
	return en_notify_inbox_sub(inputs)
});